import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwuva2gva8: FaireProductEntity = {
  token: "p_rwuva2gva8",
  type: "product",
  name: "Wally Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/92bae58c976b6a5714553103e99673d420ca374dcbd2b48e6103568e38a50dc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a71aa21d80aff803642c1049663d62c5faf37751232b35edb9f2cbfd56d038a8.jpeg",
    "https://cdn.faire.com/fastly/d24962aef6d71cef27b689adbb73a84b7ae6a7025c7ef348ff5ee16f03f834fa.jpeg",
    "https://cdn.faire.com/fastly/29c485cd228d1a42b0de216dc06a7c0707256dbdd1ea21aee16ffd52b537a227.jpeg",
    "https://cdn.faire.com/fastly/9b87b4d95deec0a27e6d1cd1400b77c0d387dd25b7e88baf7793f41ba4549217.jpeg",
    "https://cdn.faire.com/fastly/79e4eb0306f255775706f353977bd5f64d7e1277fa6bdca706b1e09b0d0d1a73.jpeg",
    "https://cdn.faire.com/fastly/a13b0e85cbc262a284efa3cab9ac04c9e02281266bd01d78a33a5396a1e4ec21.jpeg",
    "https://cdn.faire.com/fastly/667a80003f0e8a3def2d9f0daaa374cec88f23abbabfd2ab3791b4929af40ade.jpeg",
    "https://cdn.faire.com/fastly/a836bfbeff7ad98d8865840f64e1757bfad20f306c3ad15e7258fb6d76b8bc90.jpeg",
    "https://cdn.faire.com/fastly/58c684be5623d222e4dd719b08dcdbb78b1ed7f8d0288f57edeb14025b7d02d1.jpeg",
    "https://cdn.faire.com/fastly/b465080fa9c13fe0eac8d2b78c01efe5da58b2a709f23d72f93e157dec359fb3.jpeg",
    "https://cdn.faire.com/fastly/c1ba943314f81d3b5172a4a0462086a6350c0640ac5757745fd78db0871290f5.jpeg",
    "https://cdn.faire.com/fastly/0fd6d3cf26326e3b0190b498bde887ca570c9bc81d1438a0e3b6849bd662b3ec.jpeg",
    "https://cdn.faire.com/fastly/d24a122f4677c7156578b11fbf46783c1b53f944e83b578b9ff484d663d00667.jpeg",
    "https://cdn.faire.com/fastly/19fd8afc49f68ce0844ab96ff0728e356bbb94860a71d813a8daf8f3a84f5a1e.jpeg",
    "https://cdn.faire.com/fastly/29ff6532f6bcf0c76c377e1a97428345bc5947b5d91038d1dfaa9adf8c66087b.jpeg",
    "https://cdn.faire.com/fastly/b49871281b326d711e7b64f3161594948fc22a312b88525b1dd8421c7445da0c.jpeg",
    "https://cdn.faire.com/fastly/c0432c0b9064499067c7b43a4ac9915cc7389ed8cff10c01da929180db70dab9.jpeg",
    "https://cdn.faire.com/fastly/3aaac914d8760aff0915de1f81a8bd9da582aec72d2229a8c00b76e74ed07772.jpeg",
    "https://cdn.faire.com/fastly/92abacd5d4200985caaec719431067dd70f8ef165e24b8b8207b829eeb52227e.jpeg",
    "https://cdn.faire.com/fastly/395109567d932763a28509aec250e664097e162b814b4bed8debf216b9dc7d26.jpeg",
    "https://cdn.faire.com/fastly/efc6fc98da9db6271cc8783f046a272169ec6532b6e78ff866a8691efb7367af.jpeg",
    "https://cdn.faire.com/fastly/8c6a18729d493c8e44eacbc4e2dfe065ba9f18142ddf6df0fe767c7a455cfec1.jpeg",
    "https://cdn.faire.com/fastly/0538c6b903fb398e3ae39f742cbd524dea8a051503f6a5b1e727c5e134a027e9.jpeg",
    "https://cdn.faire.com/fastly/8d41469aeda79a93820f5c62abae176256ae52d7a083a3f4eea93a197bd467cd.jpeg",
    "https://cdn.faire.com/fastly/f87d2cfcc25ed12e64c68310e6cf0a6bb00e071ed497f593718b0cb39b07e27c.jpeg",
    "https://cdn.faire.com/fastly/ae9071a0bfa0e932a12b913f2f841ba64621ecb5a46297c9799cea395541dcfc.jpeg",
    "https://cdn.faire.com/fastly/2a8595519e959ff395ed75a6c56f8413695c1eb3f5285021a97e9031ec72f1b9.jpeg",
    "https://cdn.faire.com/fastly/e518e80dbdf98cd7b977eae1c851cccf4bc6a13459bc838e4a499a7d8e249640.jpeg",
    "https://cdn.faire.com/fastly/422249d24076691bc194ffd4701c812c0f20f16290693c6d6165f3181f9dc683.jpeg",
    "https://cdn.faire.com/fastly/3f916b43b648425d23b1d37a7dbf6ddcabdb4d203ae9c30727b0f985b080e1a2.jpeg",
    "https://cdn.faire.com/fastly/553f31e52f4e61b98960d7492c2c62c82425c1dd165950387573aded867f53d6.jpeg",
    "https://cdn.faire.com/fastly/3a6ced14dcec2de5b274dc6f750363102c05b4739c0ab3723acb7b49d7880b77.jpeg",
    "https://cdn.faire.com/fastly/040a7ce7fae44330898643ceb958cddf0f18c4488e84d0a5c582f7e545146d74.jpeg",
  ],
  priceDollars: 5,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThese little striped darlings add a touché of Parisian chic to any look. Like our Sneaker Socks it is made from a breathable cotton blend that you can sweat, dance, jump and play in without leaving a mark on your skin like most sock bands do!\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n70 Cotton 28 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\n𝐌𝐒𝐑𝐏:\n\n$10 USD",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:56.263Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
